<template>
    <v-card>
        <v-expansion-panels flat :value="0">
            <v-expansion-panel>
                <v-expansion-panel-header color="primary" class="white--text">
                    <v-card-title  class="pa-0 text-h6">Resumen de la transacción</v-card-title>
                    <template v-slot:actions>
                        <v-icon class="icon" right color="white">$expand</v-icon>
                    </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-card-text>
                        <label>* Antes de realizar tu pago, revisa que los datos estén correctos.</label>
                        <v-divider class="mt-2"></v-divider>
                        <v-expansion-panels flat>
                            <v-expansion-panel v-for="procedure in checkoutData" :key="'checkout'+procedure.id">
                                <v-expansion-panel-header class="px-0">
                                    <template v-slot:actions>
                                        <v-icon class="icon" left>$expand</v-icon>
                                    </template>
                                    <div class="header font-weight-bold">
                                        <div class="d-flex justify-space-between">
                                            <div>{{ procedure.nombre_tramite }} </div>
                                            <div class="text-right">{{ procedure.precio| currency }}</div>
                                        </div>

                                    </div>

                                </v-expansion-panel-header>
                                <v-expansion-panel-content color="grey lighten-4" class="transaction-concepts">
                                    <v-simple-table dense fixed-header>
                                        <tbody>
                                        <tr
                                            v-for="concept in procedure.conceptos"
                                            :key="concept.id"
                                        >
                                            <td>{{ concept.concepto }}</td>
                                            <td class="text-right">{{ concept.precio| currency }}</td>
                                        </tr>
                                        </tbody>
                                    </v-simple-table>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                        <div class="grey lighten-4" v-if="checkoutItemsNumber > 5">
                            <v-btn
                                color="normal"
                                width="100%"
                                height="50"
                                text
                                x-small
                                @click="showAllItems()"
                            >
                                Ver todos los trámites  ({{checkoutItemsNumber}} elementos)

                                <v-icon right class="float-right grey--text text--darken-2">
                                    fas fa-angle-down
                                </v-icon>

                            </v-btn>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>

                        <div class="d-flex justify-space-between text-h6">
                            <div>Total a pagar</div>
                            <div>{{checkoutTotal| currency}}</div>
                        </div>
                        <v-btn
                            width="100%"
                            color="primary"
                            class="mt-2"
                            large
                            @click="submitCart()"
                        >
                            Continuar
                        </v-btn>
                    </v-card-text>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
</template>

<script>
export default {
    name: "Checkout",
    props: ['checkoutData', 'checkoutTotal', 'checkoutItemsNumber', 'submitCart', 'showAllItems']
}
</script>

<style scoped>

</style>